var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { utils as dataUtils } from '@easydata/core';
import { Widget, WidgetGroup } from '@easyquery/core';
import { ExportDialog } from '../dialog/export_dialog';
var ExportWidget = /** @class */ (function (_super) {
    __extends(ExportWidget, _super);
    function ExportWidget(slot) {
        var _this = _super.call(this, slot) || this;
        _this.options = {
            defFormat: 'csv',
            enableExport: true
        };
        _this.clickHandler = function (ev) {
            if (!_this.slot.hasAttribute('disabled'))
                new ExportDialog(_this.context).show(_this.options.defFormat);
        };
        _this.group = WidgetGroup.All;
        return _this;
    }
    ExportWidget.prototype.getWidgetType = function () {
        return 'exportWidget';
    };
    ExportWidget.prototype.init = function (context, options) {
        _super.prototype.init.call(this, context, options);
        this.options = dataUtils.assignDeep(this.options, options);
        this.slot.addEventListener('click', this.clickHandler);
    };
    ExportWidget.prototype.refreshCore = function () {
        if (this.options.enableExport && this.context.resultTable
            && this.context.resultTable.getCachedCount() > 0) {
            this.slot.removeAttribute('disabled');
        }
        else {
            this.slot.setAttribute('disabled', '');
        }
    };
    ExportWidget.prototype.destroyCore = function () {
        this.slot.removeAttribute('disabled');
        this.slot.removeEventListener('click', this.clickHandler);
    };
    return ExportWidget;
}(Widget));
export { ExportWidget };
//# sourceMappingURL=export_widget.js.map